import { SelectionModel } from "@angular/cdk/collections";
import { Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Settings } from "../../app.settings.model";
import { AppSettings } from "src/app/app.settings";
import { ApiSevicesService } from "src/app/shared/services/api-sevices.service";
import { ToastrService } from "ngx-toastr";
import { FileDowloadService } from "src/app/shared/services/file-dowload.service";
import { PagerModule } from "src/app/shared/constants/pages.const";
import { ConfirmationComponent } from "src/app/shared/component/confirmation/confirmation.component";
@Component({
  selector: "app-query",
  templateUrl: "./query.component.html",
  styleUrls: ["./query.component.scss"],
})
export class QueryComponent implements OnInit {
  public settings: Settings;
  downloadData: any = [];
  page: any = PagerModule;

  formData: FormData | null = null;
  constructor(
    public dialog: MatDialog,
    public appSettings: AppSettings,
    public api: ApiSevicesService,
    private toast: ToastrService,
    private fileDownload: FileDowloadService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    setTimeout(() => {
      this.getQueryList();
    }, 0);
  }

  @HostListener("dragover", ["$event"]) onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("dragleave", ["$event"]) onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("drop", ["$event"]) onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const fileList = event.dataTransfer?.files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.storeFileInFormData(file);
    }
  }

  onFileChange(event: Event) {
    const fileList = (event.target as HTMLInputElement).files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.storeFileInFormData(file);
    }
  }

  private storeFileInFormData(file: File) {
    this.settings.loadingSpinner = true;
    this.formData = new FormData();
    this.formData.append("file", file);

    this.api.createQuery(this.formData).subscribe({
      next: (res: any) => {
        this.toast.success(res.message);
        this.getQueryList();
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  public displayedColumns: string[] = [
    "id",
    "fileName",
    "totalRecords",
    "queryRecords",
    "created_at",
    "status",
    "action",
  ];
  public dataSource: any;
  public selection = new SelectionModel<Element>(true, []);

  getQueryList() {
    this.settings.loadingSpinner = true;
    this.api.getQuery(this.page).subscribe({
      next: (res: any) => {
        this.dataSource = res.data;
        this.page = res.pager;
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  pageChange(e: any) {
    this.page.limit = e.pageSize;
    this.page.page = e.pageIndex + 1;
    this.getQueryList();
  }

  refresh() {
    this.getQueryList();
  }

  deleteFile(id: number, name: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        filename: name,
        title: "Delete",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.settings.loadingSpinner = true;
        this.api.deleteQuery(id).subscribe({
          next: (res: any) => {
            this.toast.success(res.message);
            this.getQueryList();
          },
          error: (error) => {
            this.toast.error(error.error.message);
            this.settings.loadingSpinner = false;
          },
        });
      }
    });
  }

  downloadFile(id: number, name: string) {
    this.settings.loadingSpinner = true;
    this.api.downloadQuery(id).subscribe({
      next: (res) => {
        this.fileDownload.downloadFIle(res, name);
        this.toast.success("File Download Succefull.");
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }
}
